import React from "react";

// Catches render/lifecycle crashes anywhere below it and shows the ACTUAL error
// instead of React unmounting the whole tree to a blank white page. Styles are
// inline on purpose so this still renders even if CSS failed to load.
class ErrorBoundary extends React.Component {
  state = { error: null, info: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    // eslint-disable-next-line no-console
    console.error("UI crash caught by ErrorBoundary:", error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.error) {
      const { error, info } = this.state;
      return (
        <div
          dir="rtl"
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "#2C3539",
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "24px",
            fontFamily: "Arial, sans-serif",
            zIndex: 99999,
            overflow: "auto"
          }}
        >
          <div
            style={{
              background: "#dc3545",
              borderRadius: "10px",
              padding: "28px",
              maxWidth: "760px",
              width: "100%",
              boxShadow: "0 4px 20px rgba(0,0,0,0.3)"
            }}
          >
            <h1 style={{ fontSize: "24px", marginBottom: "12px" }}>
              <i className="fas fa-exclamation-triangle" /> هەڵەیەک ڕوویدا
            </h1>
            <p style={{ marginBottom: "16px", lineHeight: 1.6 }}>
              پەڕەکە ناتوانرا پیشان بدرێت. ئەم زانیارییە بنێرە بۆ چاکردنەوە:
            </p>
            <pre
              dir="ltr"
              style={{
                textAlign: "left",
                background: "rgba(0,0,0,0.35)",
                borderRadius: "8px",
                padding: "14px",
                fontSize: "13px",
                lineHeight: 1.5,
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                maxHeight: "40vh",
                overflow: "auto",
                margin: 0
              }}
            >
              {String((error && error.stack) || error)}
              {info && info.componentStack ? "\n" + info.componentStack : ""}
            </pre>
            <button
              onClick={this.handleReload}
              style={{
                marginTop: "20px",
                padding: "12px 32px",
                fontSize: "16px",
                fontWeight: "bold",
                background: "#fff",
                color: "#dc3545",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer"
              }}
            >
              نوێکردنەوەی پەڕە
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
